import api from './api.js';

export const academicService = {
  // Get my classes
  getMyClasses: (params = {}) => api.get('/academic/classes/my-classes', { params }),
  
  // Get all classes (admin/teacher)
  getClasses: (params = {}) => api.get('/academic/classes', { params }),
  
  // Get class by ID
  getClass: (id) => api.get(`/academic/classes/${id}`),
  
  // Create class (admin only)
  createClass: (data) => api.post('/academic/classes', data),
  
  // Update class (admin only)
  updateClass: (id, data) => api.put(`/academic/classes/${id}`, data),
  
  // Delete class (admin only)
  deleteClass: (id) => api.delete(`/academic/classes/${id}`),
  
  // Get class students
  getClassStudents: (classId, params = {}) => 
    api.get(`/academic/classes/${classId}/students`, { params }),
  
  // Get class subjects
  getClassSubjects: (classId) => 
    api.get(`/academic/classes/${classId}/subjects`),
  
  // Get class teachers
  getClassTeachers: (classId) => 
    api.get(`/academic/classes/${classId}/teachers`),
  
  // Get subjects
  getSubjects: (params = {}) => api.get('/academic/subjects', { params }),
  
  // Get subject by ID
  getSubject: (id) => api.get(`/academic/subjects/${id}`),
  
  // Create subject (admin only)
  createSubject: (data) => api.post('/academic/subjects', data),
  
  // Update subject (admin only)
  updateSubject: (id, data) => api.put(`/academic/subjects/${id}`, data),
  
  // Delete subject (admin only)
  deleteSubject: (id) => api.delete(`/academic/subjects/${id}`),
  
  // Get subject classes
  getSubjectClasses: (subjectId) => 
    api.get(`/academic/subjects/${subjectId}/classes`),
  
  // Get subject teachers
  getSubjectTeachers: (subjectId) => 
    api.get(`/academic/subjects/${subjectId}/teachers`),
  
  // Get enrollments
  getEnrollments: (params = {}) => api.get('/academic/enrollments', { params }),
  
  // Get enrollment by ID
  getEnrollment: (id) => api.get(`/academic/enrollments/${id}`),
  
  // Create enrollment (admin only)
  createEnrollment: (data) => api.post('/academic/enrollments', data),
  
  // Update enrollment (admin only)
  updateEnrollment: (id, data) => api.put(`/academic/enrollments/${id}`, data),
  
  // Delete enrollment (admin only)
  deleteEnrollment: (id) => api.delete(`/academic/enrollments/${id}`),
  
  // Get student enrollments
  getStudentEnrollments: (studentId, params = {}) => 
    api.get(`/academic/enrollments/student/${studentId}`, { params }),
  
  // Get class enrollments
  getClassEnrollments: (classId, params = {}) => 
    api.get(`/academic/enrollments/class/${classId}`, { params }),
  
  // Get my timetable
  getMyTimetable: (params = {}) => api.get('/academic/timetables/my-schedule', { params }),
  
  // Get timetable by class
  getClassTimetable: (classId, params = {}) => 
    api.get(`/academic/timetables/class/${classId}`, { params }),
  
  // Get timetable by teacher
  getTeacherTimetable: (teacherId, params = {}) => 
    api.get(`/academic/timetables/teacher/${teacherId}`, { params }),
  
  // Get timetable by subject
  getSubjectTimetable: (subjectId, params = {}) => 
    api.get(`/academic/timetables/subject/${subjectId}`, { params }),
  
  // Create timetable entry (admin only)
  createTimetableEntry: (data) => api.post('/academic/timetables', data),
  
  // Update timetable entry (admin only)
  updateTimetableEntry: (id, data) => api.put(`/academic/timetables/${id}`, data),
  
  // Delete timetable entry (admin only)
  deleteTimetableEntry: (id) => api.delete(`/academic/timetables/${id}`),
  
  // Get academic year
  getAcademicYear: () => api.get('/academic/academic-year'),
  
  // Get current term
  getCurrentTerm: () => api.get('/academic/current-term'),
  
  // Get terms
  getTerms: (params = {}) => api.get('/academic/terms', { params }),
  
  // Get term by ID
  getTerm: (id) => api.get(`/academic/terms/${id}`),
  
  // Create term (admin only)
  createTerm: (data) => api.post('/academic/terms', data),
  
  // Update term (admin only)
  updateTerm: (id, data) => api.put(`/academic/terms/${id}`, data),
  
  // Delete term (admin only)
  deleteTerm: (id) => api.delete(`/academic/terms/${id}`),
  
  // Get academic calendar
  getAcademicCalendar: (params = {}) => 
    api.get('/academic/calendar', { params }),
  
  // Get academic events
  getAcademicEvents: (params = {}) => 
    api.get('/academic/events', { params }),
  
  // Create academic event (admin only)
  createAcademicEvent: (data) => api.post('/academic/events', data),
  
  // Update academic event (admin only)
  updateAcademicEvent: (id, data) => api.put(`/academic/events/${id}`, data),
  
  // Delete academic event (admin only)
  deleteAcademicEvent: (id) => api.delete(`/academic/events/${id}`),
  
  // Get academic statistics
  getAcademicStats: (params = {}) => 
    api.get('/academic/stats', { params }),
  
  // Export academic data (admin only)
  exportAcademicData: (params = {}) => 
    api.get('/academic/export', { 
      params, 
      responseType: 'blob' 
    }),
};
